/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreLocation } from './StoreLocation';
import {
    StoreLocationFromJSON,
    StoreLocationFromJSONTyped,
    StoreLocationToJSON,
    StoreLocationToJSONTyped,
} from './StoreLocation';
// Note: CourierPackage import removed to avoid circular dependency
// The courierPackages relationship will be handled by the API layer

/**
 * 
 * @export
 * @interface StorageSpot
 */
export interface StorageSpot {
    /**
     * 
     * @type {string}
     * @memberof StorageSpot
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof StorageSpot
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StorageSpot
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StorageSpot
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageSpot
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageSpot
     */
    storeLocationId?: number;
    /**
     * 
     * @type {StoreLocation}
     * @memberof StorageSpot
     */
    storeLocation?: StoreLocation;
    /**
     * 
     * @type {Array<any>}
     * @memberof StorageSpot
     */
    courierPackages?: Array<any>;
}

/**
 * Check if a given object implements the StorageSpot interface.
 */
export function instanceOfStorageSpot(value: object): value is StorageSpot {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function StorageSpotFromJSON(json: any): StorageSpot {
    return StorageSpotFromJSONTyped(json, false);
}

export function StorageSpotFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageSpot {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'storeLocationId': json['storeLocationId'] == null ? undefined : json['storeLocationId'],
        'storeLocation': json['storeLocation'] == null ? undefined : StoreLocationFromJSON(json['storeLocation']),
        'courierPackages': json['courierPackages'] == null ? undefined : json['courierPackages'],
    };
}

export function StorageSpotToJSON(json: any): StorageSpot {
    return StorageSpotToJSONTyped(json, false);
}

export function StorageSpotToJSONTyped(value?: StorageSpot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'description': value['description'],
        'isActive': value['isActive'],
        'id': value['id'],
        'courierId': value['courierId'],
        'storeLocationId': value['storeLocationId'],
        'storeLocation': StoreLocationToJSON(value['storeLocation']),
        'courierPackages': value['courierPackages'],
    };
}
